import React, { useEffect, useState } from 'react'
import { Tree, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { RootCategory } from '../../services/models'
import {
  buildCatalogTreeData,
  catalogExpandedKeys,
  isServiceKey
} from '../../components/CatalogTree/catalogTree'

type Props = {
    categories: RootCategory[]
}

const CatalogTreePage: React.FC<Props> = ({ categories }) => {
  const navigate = useNavigate()
  const [expandedKeys, setExpandedKeys] = useState<string[]>([])

  useEffect(() => {
    setExpandedKeys(catalogExpandedKeys(categories))
  }, [categories])

  return (
        <>
            <Typography.Title level={4}>Каталог</Typography.Title>
            <Tree
                showLine
                blockNode
                expandedKeys={expandedKeys}
                onExpand={(keys) => setExpandedKeys(keys as string[])}
                treeData={buildCatalogTreeData(categories)}
                onSelect={(keys) => {
                  const key = keys[0] as string | undefined
                  if (key && isServiceKey(key)) {
                    navigate(key)
                  }
                }}
            />
        </>
  )
}

export default CatalogTreePage
